import { Translations } from "../types";

/**
 * Traduções em Português (Brasil) - Idioma padrão
 */
export const ptBR: Translations = {
  common: {
    continue: "Continuar",
    retry: "Tentar novamente",
    ignore: "Ignorar",
    loading: "Carregando...",
    select: "Selecionar",
    error: "Erro",
    success: "Sucesso",
    cancel: "Cancelar",
    confirm: "Confirmar",
    back: "Voltar",
    close: "Fechar",
    save: "Salvar",
    delete: "Excluir",
    edit: "Editar",
    new: "Novo",
    yes: "Sim",
    no: "Não",
    or: "ou",
    and: "e",
    show: "Mostrar",
    hide: "Ocultar",
    advanced: "Avançado",
    enabled: "Ativado",
    disabled: "Desativado",
  },

  menu: {
    profile: "Perfil",
    play: "JOGAR",
    playAgain: "Jogar Novamente",
    shop: "Loja",
    options: "Opções",
    credits: "Créditos",
    referral: "Indicar",
    labs: "Labs",
    dailyRewards: "Recompensas",
    battlePass: "Passe de Batalha",
    creators: "Criadores",
    marketplace: "Marketplace",
    social: "Social",
    clan: "Clã",
    replays: "Replays",
    chooseMode: "🎮 Escolha o Modo",
    selectHowToPlay: "Selecione como quer jogar",
    playSolo: "Jogar Sozinho",
    playSoloDesc: "Batalha infinita contra a IA",
    storyMode: "Modo História",
    storyModeDesc: "Conheça a história de Arthur Ren",
    multiplayer: "Multiplayer",
    multiplayerDesc: "Crie ou entre em uma sala online",
    tournaments: "Torneios",
    tournamentsDesc: "Competições com prêmios",
    ranking: "Ranking",
    rankingDesc: "Veja sua posição global",
    experimental: "Labs",
    experimentalDesc: "Recursos experimentais",
    competitive: "Competitivo",
    competitiveDesc: "Ranking, torneios e leaderboard",
    infiniteBattle: "Batalha Infinita",
    infiniteBattleDesc: "Ondas infinitas. Sobreviva o máximo!",
    battleRoyaleDesc: "Até 300 tanques. Último sobrevive!",
    genAIMode: "Modo GenAI",
    genAIModeDesc: "Jogue ou assista IAs generativas",
    tagRoguelike: "Roguelike",
    tagTerrains: "6 Terrenos",
    tagElectricBarrier: "Barreira Elétrica",
    tagUniqueItems: "6 Itens Únicos",
    tagHot: "Hot",
    tagNew: "Novo",
    tagSkins: "SKINS",
  },

  profile: {
    personalData: "Dados Pessoais",
    birthDate: "Data de Nascimento (opcional)",
    showFullIdHint: "Clique para mostrar/ocultar ID completo",
    copyId: "Copiar ID",
    copy: "Copiar",
    crossSaveTitle: "Cross-Save:",
    crossSaveDesc: "Ao conectar sua conta Google ou Discord, seu progresso será sincronizado automaticamente entre dispositivos (web, mobile, desktop).",
    uniqueIdTitle: "Identificação Única",
    odysIdLabel: "Odys ID (para suporte)",
    odysIdHint: "Este ID é único e permanente. Use-o ao entrar em contato com o suporte.",
    session: "Sessão",
    switchAccount: "Trocar de Conta / Sair",
    switchAccountHint: "Você será desconectado e voltará para a tela de login.",
    avatarGallery: "Galeria de Avatares",
    avatarGalleryDesc: "Desbloqueie novos avatares completando capítulos do modo história",
    avatarsUnlocked: "desbloqueados",
  },

  matchSetup: {
    configureMatch: "Configurar Partida",
    selectOpponents: "Selecione o número de oponentes",
    tanksInArena: "tanques na arena",
    arenaSize: "Tamanho da Arena",
    arenaSizeDesc: "Barreira elétrica que diminui",
    units: "unidades",
    blocks: "Blocos",
    blocksDesc: "Densidade de obstáculos destrutíveis",
    blocksEstimate: "~{count} blocos",
    perfLimited: "(limitado por performance)",
    densityNone: "Nenhum",
    densityFew: "Poucos",
    densityMany: "Muitos",
    environment: "Ambiente",
    environmentDesc: "Escolha o cenário da batalha",
    availableItems: "Itens Disponíveis",
    powerUpsCount: "({count} power-ups)",
    itemsHint: "Durante a batalha, power-ups aparecem aleatoriamente na arena. Colete-os para ganhar vantagens temporárias!",
  },

  shop: {
    title: "✨ Loja",
    subtitle: "Personalize seu tanque!",
    tabs: {
      mystery: "Caixas",
      skins: "Skins",
      effects: "Efeitos",
      crystals: "Cristais",
      tanks: "Tanques",
    },
    rarity: {
      all: "Todos",
      common: "Comum",
      rare: "Raro",
      epic: "Épico",
      legendary: "Lendário",
    },
    // Mystery Boxes
    mysteryBoxes: "Caixas Misteriosas",
    mysteryBoxesDesc: "Abra caixas e ganhe tanques aleatórios!",
    mysteryBox: {
      common: "Caixa Comum",
      rare: "Caixa Rara",
      epic: "Caixa Épica",
      legendary: "Caixa Lendária",
    },
    mysteryBoxTip: "💡 Dica: Quanto maior a raridade da caixa, maior a chance de tanques épicos e lendários!",
    // Crystals
    crystalPackages: "Pacotes de Cristais",
    crystalPremiumDesc: "Cristais são usados para comprar itens premium",
    bonusAmount: "+{bonus} bônus!",
    redirectingPayment: "Redirecionando para pagamento...",
    securePaymentInfo: "Pagamentos processados com segurança via Stripe. Os cristais são adicionados instantaneamente.",
    // Tanks
    tanks: "Tanques",
    tanksUnlocked: "{unlocked}/{total} desbloqueados",
    tanksFound: "{count} tanques encontrados",
    free: "Grátis",
    // Filters
    filters: "Filtros",
    filterRarity: "Raridade",
    filterSize: "Tamanho",
    filterShots: "Disparo",
    sizeAll: "Todos",
    sizeMini: "Mini",
    sizeNormal: "Normal",
    sizeLarge: "Grande",
    sizeTitan: "Titan",
    shotSingle: "Simples",
    shotDouble: "Duplo",
    shotTriple: "Triplo",
    // Skins
    skins: "Skins",
    skinsDesc: "Personalize a aparência do seu tanque",
    equip: "Equipar",
    equippedLabel: "Equipado",
    // Effects
    effects: "Efeitos",
    effectsDesc: "Adicione efeitos visuais únicos",
    effectTypes: {
      trail: "Rastro",
      explosion: "Explosão",
      shot: "Tiro",
      aura: "Aura",
      movement: "Movimento",
      special: "Especial",
    },
    // Purchase modal
    tank: "Tanque",
    skin: "Skin",
    effect: "Efeito",
    cancel: "Cancelar",
    tankSkins: "Skins de Tanque",
    tankSkinsDesc: "Mude a aparência nos modos Solo e Multiplayer",
    skinsCount: "{count} skins",
    visualEffects: "Efeitos Visuais",
    visualEffectsDesc: "Rastros, explosões e auras!",
    effectsCount: "{count} efeitos",
    crystalDescription: "Desbloqueie itens exclusivos!",
    popular: "POPULAR",
    bonus: "+{percent}%",
    crystals: "Cristais",
    securePayment: "Pagamento seguro via Stripe",
    paymentNotConfigured: "Pagamento não configurado",
    confirmPurchase: "Confirmar Compra",
    price: "Preço",
    yourBalance: "Seu saldo",
    insufficientBalance: "⚠️ Saldo insuficiente",
    buy: "Comprar",
    noBalance: "Sem Saldo",
    use: "USAR",
    active: "✓ ATIVA",
    equipped: "equipada!",
    removed: "removida",
    unlocked: "🎉 \"{name}\" desbloqueada!",
    chipsInsufficient: "🪙 Chips insuficientes!",
    crystalsInsufficient: "💎 Cristais insuficientes!",
    chipsInfo: "💡 Ganhe Cristais com assinaturas! Chips: 10 base + 5/kill + 20/vitória",
    paymentCancelled: "Pagamento cancelado",
    crystalsAdded: "🎉 +{amount} Cristais adicionados!",
    paymentUnavailable: "Sistema de pagamento indisponível",
    openingCheckout: "Abrindo checkout...",
    effectRemoved: "Efeito removido",
    generateNewCode: "Gerar Novo Código",
    converted: "Convertido!",
  },

  ads: {
    watchForBonus: "Assistir anúncio → Chips bônus",
  },
  labs: {
    hardcoreMode: "Modo Hardcore",
    title: "🔬 Labs",
    subtitle: "Recursos experimentais e novidades",
    arMode: "Realidade Aumentada",
    arModeDesc: "Jogue Rocketanks na sua mesa usando a câmera!",
    battleRoyale: "Battle Royale",
    battleRoyaleDesc: "50 tanques, 1 vencedor. Arena elétrica que diminui!",
    vrMode: "Modo VR",
    vrModeDesc: "Em breve...",
    advancedAI: "IA Avançada",
    advancedAIDesc: "Em breve...",
    openWorld: "Mundo Aberto",
    openWorldDesc: "Em breve...",
    comingSoon: "Em breve...",
    experimentalWarning: "💡 Os recursos do Labs são experimentais e podem mudar ou ser removidos. Seu feedback é muito importante!",
    beta: "BETA",
  },

  ar: {
    checking: "Verificando suporte AR...",
    unavailable: "AR não disponível",
    unavailableReason: "Seu dispositivo não suporta Realidade Aumentada",
    tip: "💡 Dica:",
    tipDevices: [
      "Android com Chrome",
      "iOS com Safari (WebAR SDK ou câmera)",
      "Conexão HTTPS",
    ],
    startAR: "🚀 Iniciar AR",
    startCamera: "Iniciar Câmera",
    loading: "Carregando...",
    exit: "Sair",
    instructions: "👆 Toque na tela para mover • 🔄 Arraste para girar câmera",
    permission: "Modo AR",
    permissionTitle: "Modo AR",
    permissionDesc: "Aponte a câmera para uma superfície plana e veja os tanques lutando em realidade aumentada!",
    cameraAccess: "Acesso à câmera traseira",
    touchToMove: "Toque para mover e atirar",
    rotateCamera: "Gire a câmera para ver ao redor",
    // Novas traduções WebXR
    title: "Modo AR",
    notSupported: "AR não disponível",
    howItWorks: "Como funciona:",
    step1: "Aponte a câmera para uma superfície plana (mesa, chão)",
    step2: "Um retículo aparecerá - toque para posicionar o tabuleiro",
    step3: "Use o joystick e botão de tiro para jogar!",
    placeBoard: "Posicione o Tabuleiro",
    placeInstructions: "Mova o celular até ver o retículo em uma superfície plana, depois toque para posicionar",
    webARStep1: "Inicie a experiência WebAR avançada (8th Wall/Zappar)",
    webARStep2: "Aponte para o ambiente real e siga as instruções na tela",
    // Modo câmera fallback
    cameraStep1: "Permita o acesso à câmera do dispositivo",
    cameraStep2: "O tabuleiro aparecerá sobre a câmera",
    modeWebXR: "Modo AR com detecção de superfícies",
    modeWebARSDK: "Modo WebAR avançado (cross-platform)",
    modeCamera: "Modo câmera simulado",
    tryCamera: "Tentar modo câmera",
    openExternal: "Abrir externamente",
    // Lista de dispositivos suportados
    deviceAndroid: "Android com Chrome",
    deviceIOS: "iPhone/iPad com Safari",
    deviceQuest: "Oculus Quest Browser",
    // RocketAR Engine — Seleção de modo
    selectEngine: "Escolha seu Motor AR",
    selectEngineDesc: "Selecione o melhor modo para seu dispositivo",
    recommendedBadge: "Recomendado",
    unavailableBadge: "Indisponível",
    selectMode: "Selecionar",
    backToSelection: "Voltar para seleção AR",
    modeARCore: "ARCore Nativo",
    descWebXR: "AR completo com detecção de superfícies, hit-test e ancoragem no mundo real",
    descARCore: "AR nativo Android com melhor performance e rastreamento preciso",
    descWebARSDK: "WebAR multiplataforma usando 8th Wall/Zappar, funciona em iOS e Android",
    descCamera: "Câmera simples com tabuleiro 3D sobreposto, funciona em qualquer dispositivo",
    reasonNoNative: "Disponível apenas no app nativo Android",
    reasonNoWebXR: "Seu navegador não suporta WebXR AR",
    reasonNoSDK: "WebAR SDK não configurado nesta versão",
    reasonNoCamera: "Nenhuma câmera detectada neste dispositivo",
  },

  game: {
    wave: "Onda",
    lives: "Vidas",
    score: "Pontos",
    kills: "Kills",
    pause: "Pausar",
    resume: "Continuar",
    quit: "Sair",
    victory: "VITÓRIA!",
    defeat: "DERROTA",
    nextWave: "Próxima Onda",
    waveComplete: "Onda Completa!",
    enemiesDefeated: "Inimigos Derrotados",
    bonus: "Bônus",
    total: "Total",
    gameOver: "GAME OVER",
    finalScore: "Pontuação Final",
    play: "JOGAR",
    playAgain: "Jogar Novamente",
    playSubtitle: "Solo • História • Multiplayer • Torneios • Ranking",
    // GameUI
    armor: "BLINDAGEM",
    targets: "ALVOS",
    points: "PONTOS",
    radar: "RADAR",
    item: "ITEM",
    charge: "CARGA",
    nominal: "NOMINAL",
    alert: "ALERTA",
    critical: "CRÍTICO",
    powerUp: "PODER+",
    cryo: "CRYO",
    shield: "ESCUDO",
    turbo: "TURBO",
    controls: "WASD: Mover | Espaço: Atirar",
    controlsDesc: "Controles do jogo",
    forward: "W - FRENTE",
    reverse: "S - RÉ",
    left: "A - ESQ",
    right: "D - DIR",
    clickToAim: "CLIQUE PARA MIRAR COM O MOUSE",
    speed: "VELOCIDADE",
    equipment: "EQUIPAMENTO",
    empty: "VAZIO",
    heading: "PROA",
    cameraToggle: "Câmera (C)",
    // WaveComplete
    waveCompleteTitle: "ONDA {wave} COMPLETA!",
    finalVictory: "VITÓRIA!",
    enemiesEliminated: "Inimigos eliminados",
    pointsLabel: "Pontuação",
    remainingLife: "Vida restante",
    reward: "Recompensa",
    nextWaveLabel: "Próxima onda",
    continueBtn: "Continuar →",
    restartFromBeginning: "Reiniciar do Início",
    hpRestored: "+30 HP restaurado entre ondas",
    backToMenu: "Voltar ao Menu",
    // Dificuldade das ondas
    difficultyEasy: "Fácil",
    difficultyMedium: "Médio",
    difficultyHard: "Difícil",
    difficultyVeryHard: "Muito Difícil",
    difficultyExtreme: "Extremo",
    difficultyInsane: "Insano",
    difficultyImpossible: "Impossível",
    // PauseOverlay
    gamePaused: "Jogo Pausado",
    storyPaused: "História Pausada",
    youPaused: "Você pausou o jogo",
    playerPaused: "{name} pausou o jogo",
    anotherPlayerPaused: "Outro jogador pausou",
    tapToContinue: "Toque para continuar",
    gamepadPauseHint: "Pressione A para continuar • B ou Start para voltar",
    restart: "Reiniciar",
    restartCurrentRoom: "Reiniciar Sala Atual",
    pauseControls: "ESC ou P para pausar/despausar",
    confirmQuit: "Toque de novo para sair",
    confirmRestart: "Toque de novo para reiniciar",
    retryRun: "Tentar de novo",
    retryRunDesc: "Mesmo tanque, corrida nova",
    changeMode: "Trocar modo ou tanque",
  },

  tank: {
    equipped: "Equipado",
    chooseTank: "Escolha o Tanque",
    roguelikeMode: "Modo Roguelike - Terrenos mudam a cada 5 ondas",
    speed: "Velocidade",
    damage: "Dano",
    health: "Vida",
    unlocked: "Desbloqueado",
    locked: "Bloqueado",
    startBattle: "Iniciar Batalha!",
    family: "Linhagem",
    familyPredator: "Predadores",
    familyColossus: "Colossos",
    familyVenom: "Peçonhentos",
    familyStorm: "Tempestades",
    familyPhantom: "Espectros",
    familyBulwark: "Bastiões",
    familyCosmic: "Cósmicos",
    familyMythic: "Míticos",
    familyDescPredator: "Batedores velozes que caçam em disparada",
    familyDescColossus: "Fortalezas lentas de blindagem colossal",
    familyDescVenom: "Caçadores de pressão constante e precisa",
    familyDescStorm: "Artilharia devastadora de longo alcance",
    familyDescPhantom: "Infiltradores que somem do radar inimigo",
    familyDescBulwark: "Blindados de gemas com defesa viva",
    familyDescCosmic: "Controle orbital e precisão estelar",
    familyDescMythic: "Lendas vivas com poder assinatura",
    special: "Poder",
    specialElite: "Poder de elite amplificado",
    specialShield: "Blindagem Reativa",
    specialStealth: "Camuflagem Ativa",
    specialRegen: "Regeneração",
    specialExplosive: "Munição Explosiva",
    specialPiercing: "Munição Perfurante",
    specialHoming: "Munição Teleguiada",
    specialRebirth: "Renascimento da Fênix",
    specialBurn: "Sopro do Dragão",
    specialDescShield: "Reduz todo dano recebido",
    specialDescStealth: "Sem atirar por alguns segundos, você some do radar de inimigos distantes",
    specialDescRegen: "Regenera o casco após alguns segundos sem tomar dano",
    specialDescExplosive: "Impactos causam dano em área ao redor do alvo",
    specialDescPiercing: "Projéteis atravessam inimigos em linha",
    specialDescHoming: "Projéteis corrigem a rota rumo ao inimigo mais próximo",
    specialDescRebirth: "Ao ser destruído, renasce das cinzas uma vez com parte do casco",
    specialDescBurn: "Seus tiros incendeiam o alvo, causando dano contínuo",
    mastery: "Maestria",
    masteryProgress: "{kills} abates — {next} para o próximo nível",
    masteryMax: "Maestria máxima — {kills} abates",
    speedShort: "Veloc.",
    damageShort: "Dano",
    healthShort: "Vida",
    selected: "Selecionado",
    select: "Selecionar",
    tapToView: "Toque para ver",
    dragToRotate: "Arraste para girar em 3D",
    availableToBuy: "🔒 Disponíveis ({count})",
    skinLabel: "🎨 Skin: {name}",
    defaultSkin: "Padrão",
    activeSkinSolo: "Skin ativa (solo)",
    noSkin: "Sem skin (padrão)",
    unequipSkin: "Desequipar skin",
    activeEffectSolo: "Efeito ativo (solo)",
    noEffect: "Sem efeito",
    unequipEffect: "Desequipar efeito",
    skinIncompatible: "Skin equipada \"{skin}\" não é compatível com {tank}. No preview, foi aplicado visual padrão.",
  },

  multiplayer: {
    stepRoom: "Sala",
    stepArena: "Arena",
    stepWait: "Aguardar",
    stepOf: "Passo {n} de {total}",
    createRoomDesc: "Escolha a arena e convide amigos",
    joinRoomDesc: "Use o código que um amigo enviou",
    addBot: "+1 Bot",
    copyCode: "Copiar",
    createRoom: "Criar Sala",
    joinRoom: "Entrar em Sala",
    join: "Entrar",
    roomCode: "Código da Sala",
    enterCode: "Digite o código",
    waiting: "Aguardando jogadores...",
    playersReady: "{count}/{total} jogadores prontos",
    startGame: "Iniciar Partida",
    leave: "Sair",
    copied: "Copiado!",
    shareCode: "Compartilhe o código com seus amigos",
    // Lobby
    title: "MULTIPLAYER",
    subtitle: "Jogue com seus amigos",
    victoryTitle: "🏆 VITÓRIA!",
    defeatTitle: "💀 DERROTA",
    playAgain: "Jogar Novamente",
    winner: "Vencedor",
    exit: "← Sair",
    shareWhatsApp: "Compartilhar no WhatsApp",
    selectedArena: "Arena Selecionada",
    yourTank: "Seu Tanque",
    yourColor: "Sua Cor",
    playersCount: "Jogadores ({count}/4)",
    you: "(você)",
    host: "Host",
    gameMode: "Modo de Jogo",
    elimination: "Eliminação",
    eliminationDesc: "Último sobrevivente",
    deathmatch: "Deathmatch",
    deathmatchDesc: "Abates para vencer",
    timeLimit: "Tempo",
    timeLimitDesc: "Mais abates no tempo",
    livesMode: "Vidas",
    livesModeDesc: "Vidas limitadas",
    battleRoyale: "Battle Royale",
    battleRoyaleDesc: "Zona encolhe, último vivo vence",
    battleRoyaleHint: "A zona elétrica encolhe em fases e causa dano crescente a quem ficar fora dela. Sem respawn: o último tanque de pé vence. Cada eliminação acelera a próxima fase da zona.",
    brAliveCount: "{count} vivos",
    brZoneShrinking: "ZONA ENCOLHENDO!",
    brZoneNextShrink: "Zona encolhe em {seconds}s",
    killsToWin: "Abates para Vencer",
    timeLimitMinutes: "Tempo Limite (minutos)",
    livesPerPlayer: "Vidas por Jogador",
    damage: "Dano",
    speed: "Velocidade",
    health: "Vida",
    waitingPlayers: "Aguardando jogadores...",
    closeRoom: "🚫 Encerrar Sala",
    matchRules: "Regras da Partida",
    waitingHost: "Aguardando o host iniciar o jogo...",
    leaveRoom: "← Sair da Sala",
    reconnecting: "Reconectando...",
    chooseArena: "Escolha a Arena",
    chooseArenaDesc: "Esta será a arena para todos os jogadores",
    arenaLarge: "Arena Grande",
    arenaMedium: "Arena Média",
    arenaStandard: "Arena Padrão",
    random: "Aleatório",
    randomOnCreate: "Sorteado ao criar a sala",
    randomArena: "🎲 Sorteado ao criar a sala",
    yourName: "Seu nome",
    nameFromProfileHint: "Alias do perfil usado automaticamente. Para alterar, edite no perfil.",
    nextChooseArena: "Próximo: Escolher Arena →",
    connectionLost: "Conexão perdida",
    tryingToReconnect: "Tentando reconectar à sala anterior...",
    tryingReconnect: "Tentando reconectar à sala anterior...",
    disconnectedFromMatch: "Você foi desconectado de uma partida.",
    reconnect: "Reconectar",
    ignore: "Ignorar",
    waitingMorePlayers: "Aguardando mais jogadores",
    loadingArena: "Carregando arena...",
    matchStarting: "A partida vai começar!",
    countdownGo: "JÁ!",
    creatingRoom: "Criando sala...",
    joining: "Entrando...",
    connectingToServer: "Conectando ao servidor...",
    connectingServer: "Conectando ao servidor...",
    playersAndBots: "Jogadores e Bots",
    maxPlayersLabel: "Máximo de Jogadores (2-16)",
    botsFillSlots: "Bots (preencher vagas)",
    none: "Nenhum",
    botDifficulty: "Dificuldade dos Bots",
    botEasy: "Fácil",
    botNormal: "Normal",
    botHard: "Difícil",
    autoFillBots: "Auto-preencher Bots",
    removeBotsOnJoin: "Remover Bots ao Entrar",
    adaptiveBots: "Bots Adaptativos",
    tankSpecials: "Poderes de Tanque",
    tankSpecialsHint: "Poderes de linhagem (escudo, furtividade, regeneração...) valem nesta sala. Desligue para uma arena 100% neutra.",
    itemsAndPowerups: "Itens e Power-ups",
    enableAllItems: "Ativar Todos",
    disableAllItems: "Desativar Todos",
    noItemsEnabledWarning: "Nenhum item habilitado! A partida será sem power-ups.",
    botStatusSummary: "Humanos: {humans} | Bots ativos: {activeBots} | Configurado: {configuredBots} | Total previsto: {projected}/{max}",
    botFineTuning: "Ajuste fino de bots",
    modeDeathmatchWithKills: "Deathmatch ({kills} abates)",
    modeTimedWithMinutes: "{minutes}min",
    modeLivesWithCount: "{lives} vidas",
    spectatorModeTitle: "Modo Espectador",
    spectatingPlayer: "Observando {player}",
    spectatorGenericPlayer: "Jogador",
    nextSpectator: "Próximo espectador",
    exitRoom: "Sair da sala",
    alivePlayersTitle: "Jogadores Vivos",
    errorOnlyHostRules: "Apenas o host pode alterar as regras",
    errorRulesWaitingOnly: "As regras só podem ser alteradas antes da partida começar",
    errorNeedTwoPlayers: "Precisa de pelo menos 2 jogadores (humanos + bots) para iniciar",
    errorPlayersNotReady: "Nem todos os jogadores estão prontos",
    errorOnlyHostResume: "Apenas o host ou quem pausou pode despausar o jogo",
    errorColorInUse: "Cor já está em uso por outro jogador",
    errorOnlyHostRestart: "Apenas o host pode reiniciar",
    errorGameNotFinished: "Jogo ainda não terminou",
    errorConnectFailed: "Falha ao conectar ao servidor",
    errorCreateRoomFailed: "Falha ao criar sala",
    errorRoomNotFound: "Sala não encontrada",
    myFriends: "Meus Amigos",
    goToLobby: "Voltar ao Lobby",
    backToMenu: "Sair para o Menu",
  },

  br: {
    victory: "VITÓRIA!",
    champion: "Campeão do Battle Royale",
    position: "Posição",
    kills: "Abates",
    players: "Jogadores",
    score: "Pontuação",
    reward: "RECOMPENSA",
    chips: "Chips",
    claimReward: "COLETAR PRÊMIO",
    rewardClaimed: "Prêmio Coletado!",
    totalChips: "Total: {count} chips",
    backToMenu: "VOLTAR AO MENU",
    itemsNote: "Itens viram equipamento inicial da sua próxima partida",
    eliminated: "Eliminado",
    ofPlayers: "de {count} jogadores",
    spectate: "Assistir ({count})",
    menu: "Menu",
    alive: "{count} vivos",
    zone: "Zona: {size}m",
    exit: "Sair",
    winner: "VENCEDOR",
    nextTarget: "Próximo",
    matchOver: "Fim de partida",
    noSurvivors: "Ninguém sobreviveu",
    playAgain: "JOGAR DE NOVO",
    itemShield: "Escudo Extra",
    itemIntense: "Poder Intenso",
    itemFreeze: "Congelamento",
    itemHeal: "Kit Médico",
    itemMystery: "Caixa Mistério",
  },
  friends: {
    title: "Meus Amigos",
    myFriends: "Meus Amigos",
    matchesTogether: "Partidas Juntos",
    total: "Total",
    victories: "Vitórias",
    defeats: "Derrotas",
    winRate: "Taxa de Vitória",
    yourKills: "Suas Kills",
    yourDeaths: "Suas Mortes",
    kd: "K/D",
    asAllies: "Como Aliados",
    matches: "Partidas",
    estimatedMovement: "Movimento Estimado",
    distanceInMatches: "Distância em partidas juntos",
    history: "Histórico",
    firstMatch: "Primeira partida",
    lastMatch: "Última partida",
    totalSessions: "Total de sessões",
    generalStats: "Estatísticas Gerais",
    list: "Lista",
    yourJourney: "Sua Jornada",
    knownPlayers: "Jogadores Conhecidos",
    multiplayerMatches: "Partidas Multiplayer",
    performance: "Desempenho",
    totalCombat: "Combate Total",
    kills: "Kills",
    deaths: "Mortes",
    totalDistance: "Distância Total Percorrida",
    distanceEstimate: "Estimativa baseada no movimento do tanque",
    recentMatches: "Últimas Partidas",
    noFriendsYet: "Nenhum amigo ainda",
    playMultiplayer: "Jogue partidas multiplayer para começar a conhecer outros jogadores!",
    recent: "Recentes",
    distance: "Distância",
  },

  victory: {
    title: "🏆 VITÓRIA!",
    defeatTitle: "💀 DERROTA",
    yourStats: "Suas Estatísticas",
    kills: "Abates",
    deaths: "Mortes",
    finalScore: "Placar Final",
    playAgain: "Jogar Novamente",
    goToLobby: "Voltar ao Lobby",
    backToMenu: "Voltar ao Menu",
    won: "Você venceu a partida!",
    winner: "Vencedor",
  },

  options: {
    title: "⚙️ Opções",
    sound: "Som",
    music: "Música",
    sfx: "Efeitos Sonoros",
    vibration: "Vibração",
    language: "Idioma",
    graphics: "Gráficos",
    low: "Baixo",
    medium: "Médio",
    high: "Alto",
    notifications: "Notificações",
    reset: "Resetar Progresso",
    resetConfirm: "Tem certeza? Todo seu progresso será perdido.",
    // Expanded options
    mute: "Mudo",
    active: "Ativo",
    disabled: "Desligado",
    generalVolume: "Volume Geral",
    effects: "Efeitos",
    maxFps: "FPS Máximo",
    camera: "Câmera",
    cameraTop: "Topo",
    cameraAngled: "Inclinada",
    cameraFirstPerson: "1ª Pessoa",
    aiDifficulty: "Dificuldade da IA",
    // Haptics
    haptics: "Vibração",
    notSupported: "Não suportado",
    hapticIntensity: "Intensidade",
    testVibration: "Testar Vibração",
    // Voice Narration
    voiceNarration: "Narração por Voz",
    voiceNarrationDesc: "Ativa narrações de voz nos diálogos do modo história. Requer download adicional de áudios.",
    voiceVolume: "Volume da Voz",
    beta: "Beta",
    // Controls
    controls: "Controles",
    controlsDesc: "Gamepad, touch, mapeamento",
    gamepadConnected: "Controle Conectado",
    noGamepad: "Nenhum Controle Detectado",
    connectGamepadHint: "Conecte um controle Xbox, PlayStation ou Bluetooth",
    mobileCompatibility: "Compatibilidade Mobile",
    mobileAndroid: "Controles Bluetooth pareados funcionam automaticamente",
    mobileIOS: "Suporte limitado (MFi controllers apenas)",
    mobileMapping: "Automático via Gamepad API do navegador",
    visualFeedback: "Feedback Visual (Teste seu controle)",
    leftStick: "Analógico Esquerdo",
    rightStick: "Analógico Direito",
    buttonsPressed: "Botões Pressionados",
    noButtonPressed: "Nenhum botão pressionado",
    controlMapping: "Mapeamento de Controles",
    movement: "Movimento",
    shoot: "Atirar",
    useItem: "Usar Item",
    astra: "Astra (História)",
    astraHint: "quando carregado",
    jump: "Pular",
    dash: "Dash",
    pause: "Pausar",
    touch: "Touch",
    touchHint: "Botões na tela",
    gamepadSettings: "Configurações do Controle",
    deadzone: "Zona Morta (Deadzone)",
    deadzoneHint: "Ajuste se o tanque se mover sozinho",
    sensitivity: "Sensibilidade",
    invertY: "Inverter Eixo Y",
    invertYHint: "Inverte o eixo vertical do analógico",
    gamepadVibration: "Vibração do Controle",
    hideVirtualControls: "Ocultar controles virtuais quando controle conectado",
    unifiedControlsInfo: "Todos os modos (Solo, História, Battle Royale) usam os mesmos controles unificados.",
    virtualJoystick: "Joystick Virtual",
  },

  difficulty: {
    easy: "Fácil",
    easyDesc: "Inimigos mais lentos e menos dano. Perfeito para iniciantes.",
    normal: "Normal",
    normalDesc: "Experiência balanceada. O modo padrão do jogo.",
    hard: "Difícil",
    hardDesc: "Inimigos mais inteligentes com mais vida e dano. Boa sorte!",
    extreme: "Extremo",
    extremeDesc: "Desafio máximo. Apenas para os mais corajosos!",
  },

  graphics: {
    title: "Gráficos",
    subtitle: "Qualidade, sombras, resolução",
    quality: "Qualidade",
    qualityLow: "Baixa",
    qualityMedium: "Média",
    qualityHigh: "Alta",
    qualityDesc: "Ajusta automaticamente explosões, iluminação e sombras",
    explosions: "Explosões",
    advancedExplosions: "Explosões Avançadas",
    advancedExplosionsDesc: "Partículas extras e efeitos de luz",
    explosionLights: "Luzes de Explosão",
    shockwave: "Onda de Choque",
    lighting: "Iluminação",
    advancedLighting: "Iluminação Avançada",
    softShadows: "Sombras Suaves",
    postProcessing: "Bloom Neon (Pós-processamento)",
    dynamicResolution: "Resolução Dinâmica (auto)",
    shadowQuality: "Qualidade das Sombras",
    effects: "Efeitos",
    screenShake: "Tremor de Tela",
    screenShakeDesc: "Vibração da câmera em explosões",
    performance: "Performance",
    dynamicOptimization: "Otimização Dinâmica",
    dynamicOptimizationDesc: "Ajusta efeitos automaticamente para manter 30+ FPS",
    renderBackend: "Motor de Render",
    webgpuUnavailable: "WebGPU indisponível",
    webgpuActive: "WebGPU experimental ativo - melhor performance",
    fpsTarget: "FPS Alvo",
    resolution: "Resolução",
    fpsMonitor: "Monitor de FPS",
    fpsMonitorDesc: "Monitor arrastável durante o jogo",
    tensionMonitor: "Monitor de Tensão Musical",
    tensionMonitorDesc: "Mostra a intensidade da música adaptativa",
    bottomBar: "Barra Inferior",
    bottomBarDesc: "Barra com perfil, moedas e notificações",
    advancedSettings: "Configurações Avançadas",
    advancedSettingsDesc: "Ajustes detalhados de performance e efeitos",
    interfaceSection: "Interface",
    quickOptions: "Opções Rápidas",
    autoDetectReset: "Resetar para FPS e Gráficos Recomendados (Auto-Detect)",
    recommended: "RECOMENDADO",
    motion: "Movimento da interface",
    motionDesc: "Transições, brilhos e animações dos menus. \"Automático\" segue a preferência do sistema.",
    motionAuto: "Automático",
    motionFull: "Completo",
    motionReduced: "Reduzido",
    activeEffects: "Efeitos ativos:",
    autoReducedForFps: "(reduzido automaticamente para manter o FPS)",
    reducedMotionActive: "movimento reduzido",
  },

  rewards: {
    daily: "Recompensas Diárias",
    dailyDesc: "Volte todo dia para ganhar prêmios!",
    claim: "Resgatar",
    claimed: "Resgatado",
    streak: "Sequência",
    day: "Dia",
    comeBackTomorrow: "Volte amanhã!",
    // DailyRewards expanded
    week1: "Semana 1",
    week2: "Semana 2",
    week3: "Semana 3",
    week4: "Semana 4",
    megaFinal: "Mega Final",
    enterDaily: "Entre todos os dias!",
    record: "Recorde",
    currentDay: "Dia Atual",
    collect: "COLETAR!",
    nextSpecialReward: "Próxima recompensa especial",
    daysLeft: "Faltam",
    monthlyProgress: "Progresso Mensal",
    rewardCollected: "Recompensa coletada!",
    comeBackTomorrowMore: "Volte amanhã para mais",
    // New labels
    title: "🎁 Recompensas",
    sequence: "Sequência",
    xpBoost: "XP Boost!",
    chipsBoost: "Chips Boost!",
    days: "dias",
    collectReward: "Coletar Recompensa!",
    daysInRow: "dias seguidos!",
    thisMonth: "Este Mês",
    pending: "Pendente",
  },

  battlePass: {
    noActiveSubscription: "Nenhuma assinatura ativa",
    title: "Passe de Batalha",
    subtitle: "Temporada 1 • Missões • Recompensas exclusivas",
    free: "Grátis",
    premium: "Premium",
    level: "Nível",
    xp: "XP",
    unlock: "Desbloquear",
    getPremium: "Obter Premium",
    // BattlePassView expanded
    mostPopular: "MAIS POPULAR",
    choosePlan: "Escolha seu Plano",
    allPlansInclude: "Todos os planos incluem o Battle Pass Premium!",
    cancelAnytime: "Cancele a qualquer momento. Pagamento seguro via Stripe.",
    collectReward: "Coletar Recompensa",
    rewardCollected: "✓ Recompensa coletada",
    passActive: "✓ PASSE ATIVO",
    timeRemaining: "Tempo Restante",
    activatePremium: "Ativar Passe Premium",
    choosePlanDesc: "Escolha Bronze, Silver ou Gold Pass",
    missions: "📋 Missões",
    dailyMissions: "☀️ Missões Diárias",
    dailyMissionsReset: "(Reseta à meia-noite)",
    weeklyMissions: "📅 Missões Semanais",
    weeklyMissionsReset: "(Reseta às segundas)",
    loadingMissions: "Carregando missões...",
    // Subscription plans
    bronzePass: "Bronze Pass",
    silverPass: "Silver Pass",
    goldPass: "Gold Pass",
    perMonth: "/mês",
    crystalsPerDay: "cristais/dia",
    chipsPerDay: "chips/dia",
    xpAndChipsBonus: "+{percent}% XP e chips",
    noAds: "Sem anúncios",
    extraDailyMission: "+{count} missão diária",
    exclusiveSkin: "Skin exclusiva mensal",
    priorityQueue: "Fila prioritária",
    subscribe: "Assinar",
    crystalsValue: "Valor de R${value} em cristais!",
    collect: "Coletar",
    collected: "✓ Coletado",
    season: "Temporada",
    ofLevel: "de",
    backToMenu: "← Voltar ao Menu",
    rewards: "🎁 Recompensas",
    // Subscription management
    manageSubscription: "Gerenciar Assinatura",
    managePayment: "Gerenciar Pagamento",
    cancelSubscription: "Cancelar Assinatura",
    reactivateSubscription: "Reativar Assinatura",
    subscriptionActive: "Assinatura Ativa",
    subscriptionCanceled: "Assinatura Cancelada",
    expiresAt: "Expira em {date}",
    confirmCancel: "Tem certeza que deseja cancelar? Você ainda terá acesso até o final do período atual.",
    reactivate: "Reativar Assinatura",
    cancelsPeriodEnd: "Cancela no final do período",
    renewsAt: "Renova em {date}",
    daysRemaining: "Dias restantes",
    crystalsReceived: "Cristais recebidos",
    subscriptionEnding: "Sua assinatura termina em {date}",
    supportContact: "Dúvidas? contato@rocketanks.com",
    active: "Ativa",
    canceling: "Cancelando",
  },

  creators: {
    title: "🎬 Criadores",
    enterCode: "Digite um código de criador",
    yourCode: "Seu código",
    totalReferrals: "Total de indicações",
    useCode: "Usar Código",
    codeUsed: "Código já utilizado!",
    invalidCode: "Código inválido",
    ownCode: "Você não pode usar seu próprio código",
    share: "Compartilhar",
    copied: "Copiado!",
    // CreatorCode expanded
    codeApplied: "Código de {name} aplicado! {discount}% de desconto.",
    activeCode: "Código Ativo",
    enterCreatorCode: "Digite o código do criador",
    apply: "Aplicar",
    becomeCreator: "Torne-se um Criador",
    earnCommission: "Ganhe comissão quando seus seguidores comprarem usando seu código",
    supportCreator: "Apoie seu criador favorito",
    getDiscount: "e ganhe desconto nas compras",
    // CreatorDashboard
    creatorDashboard: "Painel do Criador",
    yourCreatorCode: "Seu Código de Criador",
    commission: "comissão",
    discountForFans: "desconto para fãs",
    creatorPoints: "Pontos de Criador",
    pendingValidation: "Aguardando Validação",
    pendingValidationDesc: "Seu cadastro está sendo analisado pela nossa equipe. Você receberá uma notificação quando for aprovado. Isso geralmente leva até 48 horas.",
    verifiedCreator: "Criador Verificado",
    verifiedCreatorDesc: "Parabéns! Você é um criador oficial do Rocketanks. Sua badge aparece ao lado do seu nome!",
    registerAsCreator: "Cadastrar como Criador",
    overview: "📊 Visão Geral",
    points: "⭐ Pontos",
    referrals: "👥 Referidos",
    rewardsTab: "🎁 Recompensas",
    // Dashboard Overview
    totalEarnings: "Total Ganho",
    totalUses: "Total de Usos",
    totalReferralsLabel: "Total de Referidos",
    withdrawEarnings: "Sacar Ganhos",
    minWithdrawal: "Saque mínimo: 50 cristais",
    topSupporters: "🏆 Maiores Apoiadores",
    tierBenefits: "Benefícios",
    // Points Panel
    creatorPointsBalance: "Pontos de Criador",
    totalEarnedPoints: "Total ganho: {count} pontos",
    howToEarnPoints: "Como Ganhar Pontos",
    convertPoints: "Converter Pontos",
    convertPointsDesc: "Troque seus pontos por recompensas no jogo",
    crystals: "Cristais",
    chips: "Chips",
    convertPointsBtn: "Converter {count} Pontos",
    insufficientPoints: "Pontos insuficientes (você tem {count})",
    conversionHistory: "📜 Histórico de Conversões",
    // Referrals Panel
    activeReferrals: "Ativos (30 dias)",
    inviteFriends: "Convide Amigos!",
    inviteFriendsDesc: "Compartilhe seu código e ganhe {points} pontos por cada novo jogador!",
    yourReferrals: "Seus Referidos",
    yourReferralsDesc: "Jogadores que usaram seu código ao se cadastrar",
    noReferralsYet: "Nenhum referido ainda",
    shareCodeToStart: "Compartilhe seu código para começar!",
    joinedOn: "Entrou em {date}",
    // Rewards Panel
    exclusiveCreatorItems: "Itens Exclusivos de Criador",
    exclusiveCreatorItemsDesc: "Desbloqueie itens que só criadores podem ter!",
    creatorSkin: "Skin de Criador",
    creatorSkinDesc: "Exclusiva para criadores verificados",
    creatorEffect: "Efeito de Criador",
    creatorEffectDesc: "Rastro especial exclusivo",
    pixRewards: "Recompensas em PIX",
    pixRewardsDesc: "Estamos trabalhando em formas de você receber dinheiro real!",
    pixWithdraw: "Saque via PIX",
    pixWithdrawDesc: "Converta seus ganhos em dinheiro real",
    pixMonthlyRaffle: "Sorteio PIX Mensal",
    pixMonthlyRaffleDesc: "Criadores ativos concorrem a prêmios em dinheiro",
    comingSoon: "EM BREVE",
    stayTuned: "Fique atento às novidades! Quanto mais você promover o jogo, maiores serão suas recompensas.",
    confirmRedemption: "Confirmar Resgate",
    confirmRedemptionDesc: "Você está prestes a resgatar um item exclusivo de criador.",
    cancel: "Cancelar",
    confirm: "Confirmar",
    // Register Dialog
    registerAsCreatorTitle: "Cadastrar como Criador",
    registerAsCreatorDesc: "Preencha suas redes sociais para análise. Após aprovação, você receberá uma badge de criador verificado!",
    validationNotice: "Seu cadastro será analisado manualmente em até 48 horas. Criadores aprovados recebem uma badge especial!",
    followers: "seguidores",
    fillOneSocialMedia: "Preencha pelo menos uma rede social",
    registrationError: "Erro no cadastro",
    submitForReview: "Enviar para Análise",
  },

  referral: {
    title: "Indicação",
    yourCode: "Seu código",
    copied: "✓ Copiado!",
    copy: "📋 Copiar",
    share: "📤 Compartilhar",
    friendsUseCode: "Quando amigos usam seu código, vocês dois ganham",
    bothGet: "100 ⚡ chips",
    friendCode: "Código de um amigo?",
    alreadyUsedCode: "✓ Você já usou um código de indicação",
    redeemAndEarn: "🎁 Resgatar e ganhar 100 ⚡",
    enterCode: "Digite um código!",
    codePlaceholder: "Ex: TANK-ABC12",
    errorUsingCode: "Erro ao usar código",
    connectionError: "Erro de conexão. Tente novamente.",
    shareMessage: "🎮 Jogue Rocketanks comigo! Use meu código {code} e ganhe 100 ⚡ chips grátis!\n\nhttps://rocketanks.nagentes.com",
  },

  credits: {
    title: "Créditos",
    developer: "Desenvolvedor",
    mainTester: "Testador Principal",
    sponsors: "Patrocinadores",
    sponsorsDesc: "Os maiores apoiadores do Rocketanks aparecem aqui!",
    comingSoon: "Em breve...",
    buyCrystals: "Compre cristais e veja seu nome aqui!",
    allRightsReserved: "Todos os direitos reservados",
  },

  ranked: {
    profile: "Perfil Rankeado",
    trophies: "troféus",
    victories: "Vitórias",
    defeats: "Derrotas",
    winRate: "Taxa de Vitória",
    highestTrophies: "Maior Troféus",
    currentStreak: "Sequência Atual",
    bestStreak: "Melhor sequência: {count} vitórias",
    recentMatches: "Últimas Partidas",
    classification: "Classificação",
    global: "Global",
    myLeague: "Minha Liga",
    friends: "Amigos",
    yourPosition: "Sua Posição",
    noPlayersFound: "Nenhum jogador encontrado",
  },

  tournaments: {
    title: "🏆 Torneios",
    subtitle: "Competições com prêmios",
    selectToJoin: "Selecione um torneio para participar",
    noTournamentAvailable: "Nenhum torneio disponível",
    newTournamentSoon: "Um novo torneio será criado em breve",
    players: "jogadores",
    open: "Aberto",
    almostFull: "Quase lotado",
    join: "Entrar",
    leaveTournament: "Sair do Torneio",
    entry: "Entrada",
    free: "Grátis",
    firstPlace: "1º Lugar",
    duration: "Duração",
    minutes: "min",
    tournaments: "Torneios",
    victories: "Vitórias",
    top3: "Top 3",
    prizes: "Prêmios",
    registering: "Inscrições",
    inProgress: "Em andamento",
    completed: "Finalizado",
    waitingPlayers: "Aguardando jogadores...",
    round: "Round",
    final: "Final",
    participants: "Participantes",
    yourNextMatch: "Sua próxima partida",
    place: "lugar",
    bronze: "Bronze",
    silver: "Prata",
    gold: "Ouro",
    diamond: "Diamante",
    unknownError: "Erro desconhecido",
    tournamentsPlayed: "Torneios jogados",
    tournamentsWon: "Torneios vencidos",
    top3Rate: "Taxa Top 3",
    totalPrizeWon: "Total de prêmios",
  },

  clan: {
    title: "⚔️ Clã",
    subtitle: "Junte-se a outros jogadores",
    noClan: "Você não está em um clã",
    noClanDesc: "Junte-se a um clã para participar de guerras e ganhar recompensas!",
    officialClans: "Clãs Oficiais",
    officialClansFree: "Clãs Oficiais (Gratuitos)",
    viewOfficialClans: "Ver Clãs Oficiais",
    searchClan: "Buscar Clã",
    createClan: "Criar Clã",
    joinClan: "Entrar em Clã",
    leaveClan: "Sair do Clã",
    leader: "Líder",
    coLeader: "Co-Líder",
    elder: "Ancião",
    member: "Membro",
    promote: "Promover",
    demote: "Rebaixar",
    kick: "Expulsar",
    agoMinutes: "{count}m atrás",
    agoHours: "{count}h atrás",
    agoDays: "{count}d atrás",
    perWeek: "/sem",
    noMessages: "Nenhuma mensagem ainda",
    clanMessage: "Mensagem do clã...",
    trophies: "Troféus",
    donations: "Doações",
    lastActive: "Última atividade",
    members: "Membros",
    clanLevel: "Nível do Clã",
    clanWars: "Guerras de Clã",
    clanName: "Nome do Clã",
    clanTag: "Tag do Clã",
    clanDescription: "Descrição",
    clanIcon: "Ícone",
    createClanBtn: "Criar Clã",
    searchPlaceholder: "Buscar por nome ou tag...",
    noClansFound: "Nenhum clã encontrado",
    availableClans: "7 Clãs Disponíveis",
    basedOnStoryMode: "Baseados no Modo História",
    clanTypes: "Tipos de Clã",
    publicClans: "Públicos",
    publicClansDesc: "Gratuitos, mantidos pelo Admin",
    privateClans: "Privados",
    privateClansDesc: "500💎 para criar, membros pagam 500💎",
    official: "OFICIAL",
    all: "Todos",
    beginners: "Iniciantes",
    story: "História",
    freeOfficialClansInfo: "Gratuitos! Clãs oficiais não cobram taxa de entrada.",
    adminRevenueInfo: "Admin recebe 5% dos ganhos baseado na XP dos membros",
    privateType: "Privado",
    publicType: "Público",
    publicOfficialOnly: "Apenas clãs oficiais",
    clanNamePlaceholder: "Ex: Tanques Invencíveis",
    clanTagPlaceholder: "Ex: TANK",
    clanDescriptionPlaceholder: "Descreva seu clã...",
    costSummary: "Resumo de Custos",
    createClanCost: "Criar clã:",
    memberFee: "Taxa por membro:",
    free: "Grátis",
    creating: "Criando...",
    info: "Info",
    wins: "Vitórias",
    level: "Nível",
    noDescription: "Sem descrição",
    warsComingSoon: "Em breve! Batalhe contra outros clãs por recompensas épicas.",
    inDevelopment: "Em desenvolvimento",
  },

  replays: {
    title: "🎬 Replays",
    subtitle: "Reveja suas melhores partidas",
    noReplays: "Nenhum replay salvo",
    noReplaysDesc: "Suas partidas serão salvas automaticamente",
    lastMatch: "Última Partida",
    lastMatchDesc: "Um replay por modo de jogo, salvo automaticamente",
    importReplay: "Importar Replay",
    exportReplay: "Exportar",
    shareReplay: "Compartilhar",
    deleteReplay: "Excluir",
    play: "Reproduzir",
    pause: "Pausar",
    survival: "Survival",
    multiplayer: "Multiplayer",
    story: "História",
    duration: "Duração",
    players: "Jogadores",
    wave: "Wave",
    views: "Visualizações",
    importTitle: "Importar Replay",
    importPlaceholder: "Cole o código do replay aqui...",
    import: "Importar",
    codeCopied: "Código copiado!",
    // Viewer
    viewer: "Visualizador de Replay",
    speed: "Velocidade",
    stop: "Parar",
    resume: "Continuar",
    replayEnded: "Replay finalizado",
    dragTimeline: "Arraste para navegar",
    snapshot: "Snapshot",
    events: "Eventos",
    // Tags
    tagMultiKill: "Multi-Kill",
    tagClutch: "Clutch",
    tagPerfectWave: "Perfect Wave",
    tagLongGame: "Jogo Longo",
    tagHighScore: "High Score",
    tagFlawless: "Sem Mortes",
    // Toast
    shareCopied: "Link de compartilhamento copiado!",
    exportCopied: "Replay exportado e copiado!",
    shareError: "Erro ao compartilhar replay",
    exportError: "Erro ao exportar replay",
    deleteConfirm: "Excluir este replay?",
  },

  subscription: {
    errorTitle: "Algo deu errado",
    closeError: "Fechar",
    title: "⭐ Assinatura",
    subtitle: "Desbloqueie benefícios exclusivos",
    free: "Grátis",
    freePlan: "Plano Gratuito",
    bronzePass: "Bronze Pass",
    silverPass: "Silver Pass",
    goldPass: "Gold Pass",
    perMonth: "/mês",
    dailyCrystals: "cristais/dia",
    dailyChips: "chips/dia",
    xpBonus: "+{percent}% XP",
    noAds: "Sem anúncios",
    exclusiveSkin: "Skin exclusiva mensal",
    priorityQueue: "Fila prioritária",
    dailyRewards: "Recompensas diárias",
    available: "Disponível!",
    claimedToday: "Resgatado hoje",
    claimNow: "Resgatar Agora",
    claiming: "Resgatando...",
    claimed: "Resgatado: {crystals} cristais + {chips} chips!",
    manageSubscription: "Gerenciar Assinatura",
    upgrade: "Fazer Upgrade",
    viewPlans: "Ver Planos",
    cancelSubscription: "Cancelar Assinatura",
    canceledAt: "Cancela em {date}",
    months: "meses",
    month: "mês",
    totalReceivedMonth: "Total recebido este mês:",
    totalCrystals: "cristais",
    totalChips: "chips",
    crystalsValue: "Valor de R${value} em cristais!",
    unlockDailyRewards: "Desbloqueie recompensas diárias exclusivas!",
    // SubscriptionCard dialog
    plansTitle: "Planos de Assinatura",
    plansDescription: "Escolha o plano ideal para você e receba recompensas diárias exclusivas!",
    mostPopular: "Mais Popular",
    receiveDaily: "Receba todos os dias:",
    currentPlan: "Plano Atual",
    processing: "Processando...",
    lowerPlan: "Plano Inferior",
    subscribe: "Assinar",
    loginToSubscribe: "Faça login para assinar",
    confirmCancelMessage: "Tem certeza que deseja cancelar sua assinatura? Você ainda terá acesso até o final do período atual.",
    reactivateSubscription: "Reativar Assinatura",
    paymentSecure: "Pagamento seguro via Stripe",
    cancelNoFee: "Cancele a qualquer momento, sem taxa",
    rewardsAccumulate: "Recompensas acumulam mesmo em dias sem login",
    instantUpgrade: "Upgrade instantâneo, diferença proporcional cobrada",
    claimedRewards: "✓ Resgatado: {crystals} cristais + {chips} chips!",
    // Dynamic feature templates
    featureBattlePassPremium: "Battle Pass Premium",
    featureCrystalsDaily: "cristais/dia",
    featureChipsDaily: "chips/dia",
    featureXpChipsBonus: "XP e chips",
    featureNoAds: "Sem anúncios",
    featureExclusiveSkins: "Skins exclusivas",
    featurePriorityQueue: "Fila prioritária",
    featureExtraMissions: "missão(ões) diária(s) extra",
    featureFreeChipsDaily: "chips diários",
    featureBasicAccess: "Acesso básico ao jogo",
    valueInCrystals: "Valor de R${value} em cristais!",
  },

  genAI: {
    // Personalities
    aggressive: "Agressivo 🔥",
    defensive: "Defensivo 🛡️",
    strategic: "Estratégico 🧠",
    player: "Jogador",
    // Victory messages
    battleComplete: "Batalha Concluída!",
    youWon: "Você Venceu!",
    youLost: "Você Perdeu!",
    aiVsAiMode: "Modo IA vs IA",
    playerVsAiMode: "Modo Jogador vs IA",
    model: "Modelo",
    winningModel: "Modelo Vencedor",
    menu: "Menu",
    playAgain: "Jogar Novamente",
  },

  rankedProfile: {
    title: "Perfil Rankeado",
    trophies: "troféus",
    trophiesToNextTier: "Faltam {count} troféus para {tier}",
    victories: "Vitórias",
    defeats: "Derrotas",
    winRate: "Taxa de Vitória",
    highestTrophies: "Maior Troféus",
    currentStreak: "Sequência Atual",
    bestStreak: "Melhor sequência: {count} vitórias",
    recentMatches: "Últimas Partidas",
    winsLabel: "vitórias",
  },

  marketplace: {
    explore: "Explorar",
    create: "Criar",
    myItems: "Meus Itens",
    history: "Histórico",
    createBuySell: "Crie, compre e venda itens únicos!",
    sale: "Venda",
    auction: "Leilão",
    trade: "Troca",
    free: "Grátis",
    // New labels
    title: "Marketplace",
    subtitle: "Compre, venda e troque itens com outros jogadores",
    searchItems: "Buscar itens...",
    noItemsFound: "Nenhum item encontrado",
    adjustFilters: "Tente ajustar os filtros",
    all: "Todos",
    skins: "Skins",
    effects: "Efeitos",
    tanks: "Tanques",
    badges: "Badges",
    backToMenu: "← Voltar ao Menu",
    feeInfo: "Taxa",
    // Tabs
    tabs: {
      browse: "Explorar",
      flash: "Flash",
      bundles: "Bundles",
      create: "Criar",
      myItems: "Meus Itens",
      profile: "Perfil",
      history: "Histórico",
    },
    // Fees
    fees: {
      sale: "Venda",
      auction: "Leilão",
      trade: "Troca",
      royalties: "Royalties",
      level: "Nível",
      discount: "Desconto",
    },
    // Content creation
    createContent: "🎨 Criar Conteúdo",
    createContentDesc: "Crie itens únicos para vender no Marketplace",
    contentType: "Tipo de Item",
    itemName: "Nome do Item",
    itemDescription: "Descrição (opcional)",
    skinColor: "Skin de Cor",
    visualEffect: "Efeito Visual",
    sticker: "Adesivo",
    skinColorDesc: "Cor customizada para seu tanque",
    visualEffectDesc: "Rastro ou explosão única",
    stickerDesc: "Imagem decorativa (64x64)",
    colors: "Cores",
    gradient: "Gradiente",
    primaryColor: "Cor Principal",
    secondaryColor: "Cor Secundária",
    preview: "Preview",
    uploadImage: "Imagem do Adesivo",
    clickToUpload: "Clique para fazer upload",
    clickToChange: "Clique para alterar",
    imageRules: "PNG, JPG ou WebP • Max 64x64px • Max 50KB",
    moderationWarning: "⚠️ Imagens são redimensionadas para 64x64 e passam por moderação antes de serem aprovadas.",
    submitForApproval: "Enviar para Aprovação",
    submitting: "Enviando...",
    submitted: "✓ Enviado!",
    itemSentModeration: "Item enviado para moderação!",
    moderationNotify: "Você será notificado quando for aprovado.",
    // Content rules
    contentRules: "📋 Regras de Conteúdo:",
    originalOnly: "Conteúdo original apenas",
    noOffensive: "Sem imagens ofensivas ou inapropriadas",
    noLogos: "Sem marcas registradas ou logos",
    moderationTime: "Moderação leva até 24 horas",
    // My items tabs
    selling: "À Venda",
    sold: "Vendidos",
    pending: "Pendentes",
    // Listing status
    active: "Ativo",
    expired: "Expirado",
    soldStatus: "Vendido",
    // Transaction history
    totalEarned: "Total Ganho",
    totalSpent: "Total Gasto",
    noTransactions: "Nenhuma transação ainda",
    soldTo: "Vendido para {name}",
    boughtFrom: "Comprado de {name}",
    // Listing details
    price: "Preço",
    currentBid: "Lance Atual",
    yourBid: "Seu Lance (min: {min})",
    minBid: "min",
    buyNow: "Comprar Agora",
    placeBid: "Dar Lance",
    processing: "Processando...",
    insufficientCrystals: "Cristais Insuficientes",
    purchasesUnavailable: "Compras indisponíveis",
    cancel: "Cancelar",
    // Flash sales
    noFlashSales: "Nenhuma Flash Sale Ativa",
    flashSalesDesc: "Flash Sales são ofertas relâmpago com descontos incríveis por tempo limitado. Volte mais tarde para conferir!",
    endsIn: "Termina em",
    remaining: "Restam {count} de {total}",
    soldOut: "ESGOTADO",
    buy: "Comprar",
    unavailable: "Indisponível",
    // Featured
    official: "✓ OFICIAL",
    officialDesc: "Skins e efeitos premium • Vendedor oficial da Rocketanks",
    viewItems: "Ver itens →",
    createYourSkins: "✨ Crie suas próprias skins!",
    createYourSkinsDesc: "Customize cores, efeitos e ganhe royalties nas vendas",
    // Validation errors
    nameMinChars: "Nome deve ter pelo menos 3 caracteres",
    nameBannedWord: "Nome contém termo proibido",
    invalidColor: "Cor inválida (use formato #RRGGBB)",
    imageRequired: "Imagem obrigatória para adesivos",
    fileTooLarge: "Arquivo muito grande (max {size}KB)",
    invalidImage: "Arquivo deve ser uma imagem",
    imageProcessError: "Erro ao processar imagem",
    // Offer
    offer: "Oferta",
    // Type badges
    saleType: "VENDA",
    auctionType: "LEILÃO",
    tradeType: "TROCA",
    // Telas de vendedor, pacotes e moderação
    itemSentForModeration: "Item enviado para moderação!",
    willBeNotified: "Você será avisado quando for aprovado.",
    rule1: "Somente conteúdo original ou que você tem direito de usar",
    rule2: "Nada ofensivo, violento demais ou impróprio para menores",
    rule3: "Sem marcas, logotipos ou personagens de terceiros",
    rule4: "Itens que violarem as regras são removidos sem reembolso",
    noItemsForSale: "Você não tem itens à venda",
    noItemsSold: "Nenhum item vendido ainda",
    noItemsPending: "Nenhum item aguardando aprovação",
    purchasedFrom: "Comprado de {name}",
    purchasesDisabledWarning: "Compras no Marketplace estão indisponíveis nesta conta.",
    purchasesUnavailableShort: "Compra indisponível",
    purchaseFailed: "Não foi possível concluir a compra",
    bundlesAndCollections: "Pacotes e coleções",
    bundlesDesc: "Conjuntos de itens com desconto, montados por criadores",
    createBundle: "Criar pacote",
    noBundles: "Nenhum pacote disponível",
    noBundlesDesc: "Volte mais tarde para ver novas coleções.",
    starterPack: "Pacote inicial",
    seasonal: "Sazonal",
    themed: "Temático",
    exclusive: "Exclusivo",
    buyBundle: "Comprar pacote",
    verificationSent: "Pedido de verificação enviado!",
    verificationFailed: "Não foi possível enviar o pedido de verificação",
    save: "Salvar",
    noDescription: "Sem descrição",
    edit: "Editar",
    followers: "Seguidores",
    sales: "Vendas",
    sellerLevel: "Nível de vendedor",
    progressToLevel: "Progresso até o nível {level}",
    xpToNextLevel: "Faltam {xp} XP para o próximo nível",
    maxLevelReached: "Nível máximo alcançado!",
    feeDiscount: "Desconto na taxa",
    activeListings: "Anúncios ativos",
    auctions: "Leilões",
    bundles: "Pacotes",
    creatorStats: "Estatísticas de criador",
    contentsCreated: "Conteúdos criados",
    downloads: "Downloads",
    likes: "Curtidas",
    royaltiesEarned: "Royalties recebidos",
    requestVerification: "Pedir verificação",
    verificationBenefits: "Vendedores verificados ganham um selo no perfil e mais destaque nas buscas. Cada pedido é analisado pela equipe.",
    creator: "Criador",
    creatorReq: "Publique conteúdo original no Marketplace",
    artist: "Artista",
    artistReq: "Mostre um portfólio de skins e artes",
    streamer: "Streamer",
    streamerReq: "Transmita o jogo com frequência",
  },

  shopEffects: {
    trail: "🔥 Rastro",
    explosion: "💥 Explosão",
    shot: "⚡ Disparo",
    aura: "✨ Aura",
    movement: "💨 Movimento",
    special: "🌟 Especial",
  },

  ui: {
    dailyRewards: "Recompensas Diárias",
    changeTank: "Trocar tanque",
    summary: "Resumo",
    battles: "Batalhas",
    wins: "Vitórias",
    kills: "Abates",
    winRate: "Taxa de vitória",
    touchToStart: "Toque para Iniciar",
    starting: "Iniciando...",
    mobileControls: "Mobile: Toque esquerdo para mover, direito para atirar",
    desktopControls: "Desktop: WASD ou setas para mover, Espaço para atirar",
    shopAndRewards: "Loja & Recompensas",
    shop: "Loja",
    rewards: "Recompensas",
    creators: "Criadores",
    refer: "Indicar",
    // Update notification
    newVersionAvailable: "Nova versão disponível!",
    updateReady: "Uma atualização do Rocketanks está pronta para instalar.",
    updating: "Atualizando...",
    updateNow: "Atualizar Agora",
    later: "Depois",
    // Error boundary
    somethingWentWrong: "🚀 Oops! Algo deu errado",
    unknownError: "Erro desconhecido",
    reloadPage: "Recarregar Página",
    technicalDetails: "Detalhes técnicos (para desenvolvedores)",
    screenLoadError: "Ocorreu um erro ao carregar esta tela. Por favor, tente novamente.",
    chips: "Chips",
    crystals: "Cristais",
    missions: "Missões",
    notifications: "Notificações",
    viewList: "Lista",
    viewCards: "Cards",
    backToMenu: "← Voltar ao Menu",
    offline: "Sem conexão com a internet",
    // Chapters
    comingSoon: "Em Breve",
    replay: "Rejogar",
    play: "Jogar",
  },

  story: {
    missionFailed: "MISSÃO FALHOU",
    missionFailedDesc: "Seu tanque foi destruído. Tente novamente!",
    tryAgain: "Tentar Novamente",
    backToChapters: "Voltar aos Capítulos",
    exitStory: "✕ Sair",
    tapToContinue: "Toque para continuar",
    chapter: "CAPÍTULO {chapter}",
    mode: "Modo História",
    // Story Mode page
    title: "MODO HISTÓRIA",
    subtitle: "A história de Arthur Ren e o KITSUNE-00",
    backToMenu: "← Voltar ao Menu",
    prologueLabel: "Prólogo",
    prologueTitle: "Prólogo",
    prologueDesc: "Antes do Capítulo 1: O despertar de Arthur",
    // Chapters
    chapters: {
      awakening: "Despertar",
      awakeningDesc: "O encontro com o KITSUNE-00",
      firstConflict: "Primeiro Conflito",
      firstConflictDesc: "Enfrente o Sargento RØK",
      rescue: "Resgate",
      rescueDesc: "Proteja a engenheira desertora",
      iceStorm: "Tempestade de Gelo",
      iceStormDesc: "O teste do Comandante Boreal",
      darkForest: "Floresta Sombria",
      darkForestDesc: "Enfrente o General Verdant",
      finalVolcano: "Vulcão Final",
      finalVolcanoDesc: "O Coração de Arcádia",
      shadowsOfPast: "Sombras do Passado",
      shadowsOfPastDesc: "Memórias Fragmentadas",
      iceAndSilence: "Gelo e Silêncio",
      iceAndSilenceDesc: "O Cemitério de Raposas",
      theTraitor: "O Traidor",
      theTraitorDesc: "CORVUS-7 Desperta",
      prime: "PRIME",
      primeDesc: "O Confronto Final",
    },
  },

  greetings: {
    morning: "Bom dia!",
    afternoon: "Boa tarde!",
    evening: "Boa noite!",
    lateNight: "Boa madrugada!",
    restMessage1: "Já está ficando tarde... uma partida rápida e depois descansar?",
    restMessage2: "Hora de descansar! Seu corpo agradece uma boa noite de sono.",
    restMessage3: "Você ainda acordado? Cuide da sua saúde, vá dormir!",
    firstBattle: "Pronto para sua primeira batalha?",
    startingWell: "Você está começando bem! Continue assim.",
    keepGoing: "Não desista! A vitória está próxima.",
    firstWin: "Primeira vitória conquistada! Rumo a mais!",
    moreWins: "{count} vitórias! Você está melhorando.",
    gettingBetter: "{count} vitórias! Você é um comandante habilidoso.",
    skilled: "{count} vitórias! Veterano de guerra!",
    veteran: "{count} vitórias! Lenda das batalhas!",
    legend: "{count} vitórias! Mestre supremo dos tanques!",
    master: "{count} inimigos derrotados! Imparável!",
    unstoppable: "{count} inimigos! Você é uma máquina de guerra!",
    warMachine: "{count} inimigos! Você é uma máquina de guerra!",
    richInChips: "Rico em chips! Já desbloqueou todos os tanques?",
  },

  errors: {
    connectionFailed: "Falha na conexão",
    serverError: "Erro no servidor",
    timeout: "Tempo esgotado",
    invalidInput: "Entrada inválida",
    permissionDenied: "Permissão negada",
    notFound: "Não encontrado",
    cameraError: "Erro ao acessar câmera",
    cameraInUse: "Câmera em uso por outro aplicativo",
    cameraNotFound: "Nenhuma câmera encontrada no dispositivo",
    httpsRequired: "Erro de segurança. Verifique se está usando HTTPS.",
  },

  auth: {
    tapToPlay: "🎮 Toque para Jogar",
    welcome: "Bem-vindo!",
    chooseLoginMethod: "Escolha como deseja entrar",
    loginWithGoogle: "Entrar com Google",
    loginWithDiscord: "Entrar com Discord",
    loginWithEmail: "Entrar com Email",
    comingSoon: "Em breve",
    unavailable: "Indisponível",
    emailCodeSent: "📬 Digite o código de 6 dígitos enviado para seu email.",
    emailCodePrompt: "Enviaremos um código de verificação para seu email.",
    sendCode: "Enviar código →",
    sending: "⏳ Enviando...",
    verifying: "⏳ Verificando...",
    confirmAndLogin: "✓ Confirmar e Entrar",
    useAnotherEmail: "← Usar outro email",
    useAnotherAccount: "🔄 Usar outra conta",
    completeProfile: "🎯 Complete seu Perfil",
    profileInfoNeeded: "Precisamos de algumas informações para começar",
    email: "Email",
    fullName: "Nome completo",
    fullNamePrivate: "(privado)",
    publicAlias: "Alias público",
    aliasChars: "(3-16 caracteres)",
    birthDate: "Data de nascimento",
    yourName: "Seu nome",
    yourAlias: "seu_alias",
    yourEmail: "seu@email.com",
    saving: "⏳ Salvando...",
    saveAndPlay: "🚀 Salvar e Jogar!",
    welcomeBack: "Bem-vindo de volta,",
    playNow: "🎮 Jogar Agora",
    starting: "⏳ Iniciando...",
    termsAgree: "Li e concordo com os",
    termsOfUse: "Termos de Uso",
    privacyPolicy: "Política de Privacidade",
    aliasInUse: "Alias já está em uso ou é inválido",
    aliasInvalid: "Alias inválido",
    // Bio / Profile
    bio: "Bio",
    bioPlaceholder: "Conte um pouco sobre você...",
    clickToAddBio: "Clique para adicionar uma bio...",
    change: "Trocar",
    // Validation errors
    invalidEmail: "Email inválido",
    fullNameMinLength: "Nome completo deve ter pelo menos 3 caracteres",
    aliasMinLength: "Alias deve ter 3-16 caracteres (letras, números, _)",
    birthDateRequired: "Data de nascimento é obrigatória",
    profileSaveFailed: "Falha ao salvar perfil",
    connectionError: "Erro de conexão. Tente novamente.",
  },

  admin: {
    title: "Painel Administrativo",
    loginError: "Erro ao fazer login",
    playerNotFound: "Jogador não encontrado",
    announcementPlaceholder: "Digite o conteúdo do anúncio aqui...",
    search: "Buscar",
    searchPlayer: "Buscar Jogador",
    wins: "Vitórias",
    systemSettings: "Configurações do Sistema",
    refreshData: "Atualizar dados",
    settingLocked: "Esta configuração está bloqueada",
    dailyRewards: "Recompensas Diárias",
    successRate: "Taxa de sucesso",
    playerUUID: "UUID do jogador",
    minAge: "Idade mínima",
    maxAge: "Idade máxima",
    resetMemoriesConfirm: "Tem certeza que deseja resetar TODAS as memórias da IA?",
    genaiLearning: "Sistema de Aprendizado da IA",
    totalMemories: "Total de Memórias",
    totalMatches: "Total de Partidas",
    uniquePlayers: "Jogadores Únicos",
    topPlayers: "Top Jogadores",
    recentMatches: "Partidas Recentes",
    resetPlayerMemory: "Resetar memória do jogador",
    resetAllMemories: "Resetar todas as memórias",
    noMemoriesYet: "Nenhuma memória registrada ainda",
    announcements: "Anúncios",
    players: "Jogadores",
    dashboard: "Dashboard",
    config: "Configuração",
  },
  
  legal: {
    // Common
    back: "Voltar",
    lastUpdated: "Última atualização",
    contactUs: "Fale Conosco",
    generalSupport: "Suporte Geral",
    privacyEmail: "Email de Privacidade",
    companyInfo: "NAgentes Tecnologia LTDA • CNPJ: XX.XXX.XXX/0001-XX • Brasil",
    legalQuestions: "Questões Legais",
    introduction: "Introdução",
    
    // Terms of Use page
    termsTitle: "Termos de Uso",
    termsSubtitle: "Suas regras para uma experiência justa e divertida",
    termsHeroTitle: "Regras do Jogo",
    termsHeroDesc: "Termos e condições para uso do Rocketanks.",
    termsSummary: "Resumindo",
    termsSummaryDesc: "O que você precisa saber",
    
    // Terms intro
    termsWelcome: "Bem-vindo ao Rocketanks!",
    termsWelcomeDesc: "Ao criar uma conta ou usar o Rocketanks, você concorda com estes Termos de Uso. Leia com atenção. Se não concordar com algum termo, por favor não utilize nossos serviços.",
    termsAgeTitle: "Classificação Etária",
    termsAgeDesc: "O Rocketanks é classificado para maiores de 10 anos. Menores de 18 anos devem ter consentimento dos pais ou responsáveis legais para jogar. Compras no aplicativo requerem autorização de um adulto responsável.",
    
    // Terms sections titles
    termsLicense: "Licença de Uso",
    termsAccount: "Sua Conta",
    termsConduct: "Código de Conduta",
    termsPurchases: "Compras e Moedas Virtuais",
    termsIntellectual: "Propriedade Intelectual",
    termsAvailability: "Disponibilidade do Serviço",
    termsLiability: "Limitação de Responsabilidade",
    termsPenalties: "Violações e Penalidades",
    termsChanges: "Alterações nos Termos",
    termsLaw: "Lei Aplicável",
    
    // Terms License content
    termsLicenseDesc: "Concedemos a você uma licença limitada, pessoal, não-exclusiva, não-transferível e revogável para usar o Rocketanks de acordo com estes termos.",
    termsYouCan: "Você pode:",
    termsYouCanPlay: "Jogar para entretenimento pessoal",
    termsYouCanPurchase: "Fazer compras in-app para melhorar sua experiência",
    termsYouCanCreate: "Criar e compartilhar conteúdo do jogo (streams, vídeos)",
    termsYouCanParticipate: "Participar da comunidade e eventos",
    termsYouCannot: "Você NÃO pode:",
    termsYouCannotModify: "Modificar, hackear ou fazer engenharia reversa",
    termsYouCannotSell: "Vender ou comercializar itens virtuais fora do jogo",
    termsYouCannotMultiple: "Criar múltiplas contas para ganhar vantagem",
    termsYouCannotBots: "Usar bots, cheats ou software de terceiros",
    
    // Terms Account content
    termsAccountDesc: "Você é responsável por manter a segurança de sua conta e por todas as atividades realizadas nela.",
    termsAccountSecurity: "Segurança",
    termsAccountSecurityShare: "Não compartilhe sua conta",
    termsAccountSecurityAuth: "Use autenticação segura",
    termsAccountSecurityReport: "Reporte acessos suspeitos",
    termsAccountName: "Seu Nome",
    termsAccountNameRespect: "Seja respeitoso no alias",
    termsAccountNameOffensive: "Nada ofensivo ou inapropriado",
    termsAccountNameChange: "Podemos alterar nomes impróprios",
    termsAccountWarning: "Reservamo-nos o direito de suspender contas que violem estes termos.",
    
    // Terms Conduct content
    termsCondictDesc: "Para manter a comunidade saudável, esperamos que todos sigam estas regras:",
    termsRespectPlayers: "Respeite outros jogadores",
    termsRespectPlayersDesc: "Seja educado no chat e durante as partidas",
    termsPlayFair: "Jogue limpo",
    termsPlayFairDesc: "Não use exploits, bugs ou trapaças",
    termsReportViolations: "Denuncie violações",
    termsReportViolationsDesc: "Ajude a manter a comunidade segura",
    termsNoToxicity: "Sem toxicidade",
    termsNoToxicityDesc: "Assédio, discurso de ódio, bullying = banimento",
    termsNoSpam: "Sem spam",
    termsNoSpamDesc: "Publicidade ou flood não são permitidos",
    
    // Terms Purchases content
    termsCurrencies: "Cristais e Chips",
    termsCurrenciesDesc: "São moedas virtuais usadas para adquirir itens no jogo. Elas não têm valor monetário real e não podem ser trocadas por dinheiro.",
    termsPurchasesFinal: "Todas as compras são finais e não reembolsáveis, exceto onde exigido por lei",
    termsPricesChange: "Preços podem mudar a qualquer momento",
    termsVirtualItems: "Itens virtuais pertencem à NAgentes e são licenciados para você",
    termsNoRefundShutdown: "Em caso de encerramento do jogo, moedas não utilizadas não serão reembolsadas",
    termsConsumerProtection: "Proteção ao Consumidor:",
    termsConsumerProtectionDesc: "Menores de 18 anos precisam de autorização dos pais para compras. Oferecemos controles parentais para limitar gastos.",
    
    // Terms Intellectual content
    termsIntellectualDesc: "O Rocketanks, incluindo todos os gráficos, música, código, personagens, nomes e design são propriedade da NAgentes Tecnologia.",
    termsContentCreation: "Criação de Conteúdo:",
    termsContentCreationDesc: "Você pode criar vídeos, streams e conteúdo sobre o Rocketanks, desde que:",
    termsContentNotOfficial: "Não afirme que é conteúdo oficial",
    termsContentNotMonetize: "Não monetize de forma que engane consumidores",
    termsContentCredit: "Dê crédito ao jogo original",
    
    // Terms Availability content
    termsAvailabilityDesc: "Nos esforçamos para manter o Rocketanks sempre disponível, mas não garantimos disponibilidade ininterrupta.",
    termsMaintenanceNotice: "Manutenções podem ocorrer com ou sem aviso prévio",
    termsServiceModify: "O serviço pode ser modificado ou encerrado a qualquer momento",
    termsProgressLoss: "Não nos responsabilizamos por perdas de progresso em casos de força maior",
    
    // Terms Liability content
    termsLiabilityDesc: "O Rocketanks é fornecido \"como está\". Dentro dos limites permitidos pela lei:",
    termsNoBugGuarantee: "Não garantimos que o jogo será livre de bugs ou erros",
    termsNoIndirectDamage: "Não nos responsabilizamos por danos indiretos ou consequenciais",
    termsMaxLiability: "Nossa responsabilidade máxima é limitada ao valor pago nos últimos 12 meses",
    termsLiabilityImportant: "Importante:",
    termsLiabilityImportantDesc: "Estas limitações não afetam direitos que você tenha por lei e que não podem ser limitados ou excluídos.",
    
    // Terms Penalties content
    termsPenaltiesDesc: "Violações destes termos podem resultar em:",
    termsWarning: "Advertência",
    termsWarningDesc: "Primeira violação leve",
    termsSuspension: "Suspensão",
    termsSuspensionDesc: "Temporária (1-30 dias)",
    termsBan: "Banimento",
    termsBanDesc: "Permanente sem reembolso",
    termsPenaltiesSeverity: "A severidade depende da natureza e frequência da violação. Decisões são tomadas a nosso critério.",
    
    // Terms Changes content
    termsChangesDesc: "Podemos atualizar estes termos periodicamente. Quando fizermos alterações significativas:",
    termsChangesNotify: "Notificaremos você por email ou no app",
    termsChangesDate: "A data de \"última atualização\" será modificada",
    termsChangesAccept: "Continuar usando o jogo significa aceitar os novos termos",
    
    // Terms Law content
    termsLawDesc: "Estes termos são regidos pelas leis da República Federativa do Brasil.",
    termsLawCourt: "Qualquer disputa será resolvida nos tribunais competentes da cidade de São Paulo, SP.",
    termsFriendlyResolution: "Resolução Amigável:",
    termsFriendlyResolutionDesc: "Antes de qualquer ação legal, encorajamos que você entre em contato conosco. Muitos problemas podem ser resolvidos de forma rápida e amigável.",
    
    // Terms Summary content
    termsSummaryPlay: "Divirta-se - O Rocketanks é para diversão!",
    termsSummaryBeNice: "Seja legal - Respeite outros jogadores",
    termsSummaryPlayFair: "Jogue limpo - Nada de cheats ou hacks",
    termsSummaryFinal: "Compras são finais - Pense antes de comprar",
    termsSummaryContact: "Fale conosco - Estamos aqui para ajudar",
    
    // Privacy Policy page
    privacyTitle: "Política de Privacidade",
    privacySubtitle: "Como protegemos seus dados",
    privacyHeroTitle: "Sua privacidade é importante",
    privacyHeroDesc: "Explicamos de forma clara como tratamos seus dados no Rocketanks.",
    
    // Privacy intro
    privacyIntro: "Introdução",
    privacyIntroDesc: "A NAgentes Tecnologia, desenvolvedora do Rocketanks, está comprometida em proteger sua privacidade. Esta política explica quais informações coletamos, como as usamos e quais são seus direitos em relação aos seus dados pessoais.",
    
    // Privacy sections titles
    privacyCollection: "Dados que Coletamos",
    privacyUsage: "Como Usamos seus Dados",
    privacySecurity: "Segurança dos Dados",
    privacyRights: "Seus Direitos (LGPD)",
    privacyCookies: "Cookies e Armazenamento Local",
    privacyMinors: "Proteção de Menores",
    privacyChanges: "Alterações nesta Política",
    
    // Privacy Collection content
    privacyAccountData: "Dados de Conta",
    privacyAccountEmail: "Email (para login e comunicação)",
    privacyAccountUsername: "Nome de usuário (alias público)",
    privacyAccountBirth: "Data de nascimento (para verificação de idade)",
    privacyAccountAvatar: "Avatar selecionado",
    privacyGameData: "Dados de Jogo",
    privacyGameProgress: "Progresso no jogo (tanques, fases, moedas)",
    privacyGameStats: "Estatísticas de partidas (vitórias, derrotas, pontuação)",
    privacyGameSettings: "Preferências de configuração",
    privacyGamePurchases: "Histórico de compras in-app",
    privacyTechData: "Dados Técnicos",
    privacyTechDevice: "Tipo de dispositivo e sistema operacional",
    privacyTechIP: "Endereço IP (para segurança)",
    privacyTechLogs: "Logs de erro e diagnóstico",
    
    // Privacy Usage content
    privacyUsageImprove: "Fornecer e melhorar a experiência de jogo",
    privacyUsageSave: "Salvar seu progresso na nuvem",
    privacyUsagePayments: "Processar pagamentos e compras",
    privacyUsageNotify: "Enviar notificações importantes sobre sua conta",
    privacyUsageFraud: "Prevenir fraudes e uso indevido",
    privacyUsageMatchmaking: "Melhorar o matchmaking e balanceamento",
    privacyNeverSell: "Nunca vendemos seus dados a terceiros",
    privacyNeverShare: "Nunca compartilhamos seu email com anunciantes",
    
    // Privacy Security content
    privacySecurityDesc: "Implementamos medidas de segurança de nível empresarial para proteger seus dados:",
    privacySecurityTLS: "Criptografia TLS/SSL",
    privacySecurityTLSDesc: "Todos os dados em trânsito são criptografados",
    privacySecurityDB: "Banco de dados seguro",
    privacySecurityDBDesc: "Dados armazenados com criptografia em repouso",
    privacySecurityTokens: "Tokens seguros",
    privacySecurityTokensDesc: "Autenticação via OAuth2 e JWT",
    privacySecurityMonitor: "Monitoramento",
    privacySecurityMonitorDesc: "Detecção de acessos suspeitos 24/7",
    
    // LGPD Rights (Brazil)
    lgpdRights: "Conforme a Lei Geral de Proteção de Dados (LGPD), você tem os seguintes direitos:",
    lgpdAccess: "Acesso",
    lgpdAccessDesc: "Saber quais dados temos sobre você",
    lgpdCorrection: "Correção",
    lgpdCorrectionDesc: "Corrigir dados incorretos ou incompletos",
    lgpdDeletion: "Eliminação",
    lgpdDeletionDesc: "Solicitar a exclusão dos seus dados",
    lgpdPortability: "Portabilidade",
    lgpdPortabilityDesc: "Receber seus dados em formato legível",
    lgpdRevocation: "Revogação",
    lgpdRevocationDesc: "Retirar consentimento a qualquer momento",
    lgpdExercise: "Para exercer seus direitos:",
    
    // Privacy Cookies content
    privacyCookiesDesc: "Utilizamos armazenamento local (localStorage) para:",
    privacyCookiesLogin: "Manter você logado entre sessões",
    privacyCookiesSettings: "Salvar preferências de configuração",
    privacyCookiesCache: "Armazenar cache de recursos do jogo",
    privacyCookiesNoTracking: "Não usamos cookies de rastreamento de terceiros para publicidade direcionada.",
    
    // Privacy Minors content
    privacyMinorsAge: "O Rocketanks é classificado para maiores de 10 anos.",
    privacyMinorsImportant: "Importante:",
    privacyMinorsConsent: "Menores de 18 anos precisam de consentimento dos pais",
    privacyMinorsNoCollect: "Não coletamos dados de menores de 13 anos intencionalmente",
    privacyMinorsPurchases: "Compras in-app requerem autorização de responsável",
    
    // Privacy Changes content
    privacyChangesDesc: "Podemos atualizar esta política periodicamente. Quando fizermos alterações significativas:",
    privacyChangesNotify: "Notificaremos você por email ou no app",
    privacyChangesDate: "A data de \"última atualização\" será modificada",
    privacyChangesEffective: "Alterações entram em vigor 30 dias após a publicação",
  },

  infinite: {
    bestWave: "Recorde",
    newRecord: "NOVO RECORDE!",
    noRecordYet: "Sem recorde ainda",
    medals: "Medalhas",
    nextMedal: "Próxima medalha: onda {wave}",
    statusBurning: "Em chamas",
    statusSoaked: "Encharcado",
    statusMuddy: "Enlameado",
    statusHint: "A água apaga o fogo",
    contract: "Desafio da onda",
    contractComplete: "Desafio cumprido!",
    contractFailed: "Desafio perdido",
    contractReward: "Bônus",
    chooseUpgrade: "Escolha uma melhoria",
    chooseUpgradeHint: "Ela vale até o fim da corrida",
    reroll: "Trocar cartas",
    rerollsLeft: "{count} restantes",
    skipDraft: "Pular",
    yourBuild: "Seu tanque",
    waveLabel: "Onda {wave}",
    bossWaveIn: "CHEFE em {count}",
    bossWaveNow: "CHEFE",
    eliteWave: "ELITE",
    hazardWarning: "Cuidado",
    tapToSkip: "Toque para pular",
    runSummary: "Resumo da corrida",
    contractsCleared: "Desafios cumpridos",

    cards: {
      twin_barrel: { title: "Cano Duplo", description: "+1 tiro por rajada, cada um um pouco mais fraco" },
      heavy_shell: { title: "Munição Pesada", description: "+18% de dano" },
      piercing_round: { title: "Projétil Perfurante", description: "A bala atravessa mais um inimigo" },
      hot_powder: { title: "Pólvora Quente", description: "Tiro 25% mais rápido — mais fácil de acertar" },
      siege_cannon: { title: "Canhão de Cerco", description: "+55% de dano, mas a bala viaja mais devagar" },
      reinforced_hull: { title: "Casco Reforçado", description: "+25 de vida máxima" },
      composite_armor: { title: "Blindagem Composta", description: "Absorve 18% do dano recebido" },
      heavy_plating: { title: "Placa Pesada", description: "Absorve 32% do dano e +40 de vida, mas te deixa lento" },
      field_repair: { title: "Reparo de Campo", description: "+18 de cura ao fim de cada onda" },
      race_treads: { title: "Esteira de Corrida", description: "+12% de velocidade" },
      amphibious_kit: { title: "Casco Anfíbio", description: "Água e lama quase não te freiam" },
      studded_treads: { title: "Esteira Cravada", description: "Você não derrapa mais no gelo" },
      heat_shield: { title: "Escudo Térmico", description: "A lava faz bem menos dano" },
      all_terrain: { title: "Todo-o-Terreno", description: "Água, gelo e lava quase não te atrapalham" },
      item_magnet: { title: "Ímã de Itens", description: "Itens próximos vêm até você" },
      strong_magnet: { title: "Ímã Potente", description: "Puxa itens de muito mais longe" },
      scavenger: { title: "Catador", description: "+4 de vida a cada inimigo destruído" },
      second_thought: { title: "Pensando Melhor", description: "+1 troca de cartas por corrida" },
      glass_cannon: { title: "Canhão de Vidro", description: "+60% de dano, mas −35 de vida máxima" },
      reckless_charge: { title: "Investida", description: "+30% de velocidade, mas −20 de vida máxima" },
      overload: { title: "Sobrecarga", description: "+35% de dano e +2 tiros, mas −25 de vida" },
      vampire_core: { title: "Núcleo Vampiro", description: "+10 de vida por abate, com dano um pouco menor" },
      bulwark: { title: "Baluarte", description: "+90 de vida e cura extra, mas mais lento" },
      storm_of_lead: { title: "Tempestade de Chumbo", description: "+3 tiros por rajada, cada um mais fraco" },
    },

    contracts: {
      no_damage: { title: "Intacto", description: "Termine a onda sem levar dano" },
      no_items: { title: "Só na Mira", description: "Termine a onda sem usar itens" },
      speedrun: { title: "Relâmpago", description: "Limpe a onda em menos de {target}s" },
      combo: { title: "Sequência", description: "{target} abates em 6 segundos" },
      priority_target: { title: "Alvo Marcado", description: "Destrua o {target} antes de qualquer outro" },
      demolisher: { title: "Demolidor", description: "Destrua {target} blocos" },
      long_range: { title: "Tiro Longo", description: "{target} abates de longe" },
      close_quarters: { title: "Corpo a Corpo", description: "{target} abates bem de perto" },
      full_health: { title: "Inteiro", description: "Termine a onda com mais de {target}% de vida" },
      firewalker: { title: "Andarilho do Fogo", description: "{target} abates enquanto está em chamas" },
    },

    enemyKinds: {
      normal: "Soldado",
      heavy: "Blindado",
      fast: "Veloz",
      sniper: "Atirador",
      boss: "Comandante",
    },

    archetypes: {
      open: "Campo Aberto",
      lake: "Lago Partido",
      marsh: "Charco",
      glacier: "Geleira Rachada",
      archipelago: "Arquipélago",
      forge: "A Forja",
      crater: "Caldeira",
    },

    worldModifiers: {
      none: { title: "", description: "" },
      swarm: { title: "Enxame", description: "Muitos inimigos, todos frágeis" },
      juggernaut: { title: "Colossos", description: "Poucos inimigos, muito resistentes" },
      sharpshooter: { title: "Atiradores", description: "Franco-atiradores em toda parte" },
      blitz: { title: "Blitz", description: "Todo mundo mais rápido" },
      volatile: { title: "Voláteis", description: "Inimigos explodem ao morrer" },
    },

    hazards: {
      water: "Água — você fica lento",
      lava: "Lava — queima!",
      ice: "Gelo — você derrapa",
      mud: "Lama — você atola",
    },
  },
  sofa: {
    menuTitle: "Modo Sofá",
    menuDesc: "Até 4 jogadores na mesma tela, no celular, no PC ou na TV. Controles ou teclado; CPUs nas vagas livres.",
    title: "Modo Sofá",
    subtitle: "Até 4 jogadores na mesma tela: celular, PC ou TV",
    player: "Jogador {n}",
    keyboardJoin: "ou {key} no teclado",
    joined: "Pronto",
    leaveHint: "B para sair",
    modeCoop: "Cooperativo",
    modeCoopDesc: "Juntos contra ondas de bots. 3 vidas cada; quem cair volta no fim da onda.",
    modeVersus: "Duelo",
    modeVersusDesc: "Todos contra todos. Vence quem fizer {kills} abates primeiro.",
    arena: "Arena",
    back: "Voltar",
    tvTitle: "Jogar na TV (opcional)",
    tvStep1: "Pareie os controles no aparelho que roda o jogo (até 4). No PC, o teclado também vale.",
    tvStep2: "Leve a imagem para a TV: AirPlay no iPhone, Smart View no Android ou cabo HDMI no PC.",
    tvStep3: "Ligue o Modo Jogo da TV para menos atraso. No celular, jogue deitado.",
    noGamepadApi: "Este navegador não lê controles. Use o teclado ou outro navegador.",
    keyboardWasd: "Teclado: WASD + Espaço",
    keyboardArrows: "Teclado: Setas + Enter",
    wave: "Onda {n}",
    firstTo: "Primeiro a {n}",
    getReady: "Prepare-se",
    go: "Lutem!",
    waveCleared: "Onda {n} limpa!",
    nextWaveIn: "Próxima onda em {n}",
    respawnIn: "Voltando em {n}",
    paused: "Pausado",
    quit: "Sair",
    pauseHint: "Direcional escolhe · A confirma · B ou Start continua",
    disconnected: "Controle do Jogador {n} desconectado",
    reconnectHint: "Ligue o controle e aperte A",
    victory: "{name} venceu!",
    reachedWave: "Vocês chegaram à onda {n}",
    rematch: "Revanche",
    overHint: "Direcional escolhe · A confirma · B volta ao lobby",
    lives: "Vidas",
    modeRivals: "Disputa",
    modeRivalsDesc: "As mesmas ondas, mas cada abate vale pontos para quem atirou. Após {waves} ondas, vence o maior placar.",
    difficulty: "Dificuldade",
    diffEasy: "Fácil",
    diffNormal: "Normal",
    diffHard: "Difícil",
    killsLabel: "Abates para vencer",
    noSpecial: "Sem poder",
    score: "{n} pts",
    waitingRescue: "Fora! Seu parceiro pode te resgatar",
    rescuing: "Resgatando… {n}%",
    annKilled: "{a} abateu {b}!",
    annDown: "{name} caiu!",
    annEliminated: "{name} está fora — vá resgatar!",
    annRescued: "{a} resgatou {b}!",
    annBoss: "Chefe chegando!",
    annBossDown: "Chefe derrotado!",
    annPickup: "{name}: {item}",
    hintPad: "Stick esq. move · Stick dir. mira · RT/A atira (segure para carregar) · LB/X usa item",
    hintWasd: "WASD move · Espaço atira (segure para carregar) · E/Q usa item",
    hintArrows: "Setas movem · Enter atira (segure para carregar) · Shift dir. usa item",
    accuracy: "Precisão",
    damage: "Dano",
    reward: "+{n} chips",
    newRecord: "Novo recorde!",
    draw: "Empate!",
    stepJoin: "Jogadores",
    stepTanks: "Tanques",
    stepSetup: "Partida",
    stepOf: "Passo {n} de {total}",
    joinTitle: "Quem vai jogar?",
    joinText: "Escolha quantos tanques. Quem apertar A no controle (ou Espaço/Enter no teclado) joga; as outras vagas ficam com a CPU.",
    continue: "Continuar",
    continueHint: "A ou Start para escolher os tanques",
    confirmTank: "Confirmar ({key})",
    tanksTitle: "Escolha seu tanque",
    tanksText: "Leve a sua ficha até um tanque e confirme. As CPUs sorteiam o delas.",
    tanksPadHint: "Direcional escolhe · LB/RB poder · A confirma · B volta",
    tanksKeysHint: "Teclado: WASD, Q/E e Espaço · setas, [ ] e Enter",
    killsShort: "{n} abates",
    setupTitle: "Monte a partida",
    setupText: "Modo, dificuldade e arena. Qualquer jogador pode escolher.",
    modeLabel: "Modo",
    startMatch: "Começar partida",
    setupHint: "▲ ▼ escolhe · ◀ ▶ muda · A confirma · Start começa · B volta",
    leave: "Sair",
    prevPower: "Poder anterior",
    nextPower: "Próximo poder",
    pairTitle: "Como parear um controle",
    pairWhereIos: "No iPhone, abra Ajustes → Bluetooth e toque no nome do controle em “Outros dispositivos”.",
    pairWhereAndroid: "No Android, abra Configurações → Bluetooth (ou Dispositivos conectados) → Parear novo dispositivo e toque no nome do controle.",
    pairWhereDesktop: "No computador, abra as configurações de Bluetooth, adicione um dispositivo e escolha o controle.",
    pairBrandOther: "Outros",
    pairXbox: "Ligue no botão Xbox e segure o botão de parear (em cima, perto da entrada USB) até o Xbox piscar rápido.",
    pairPlaystation: "Segure Create e PS juntos (Share e PS no PS4) até a luz piscar rápido.",
    pairNintendo: "Pro Controller: segure o botão sync, em cima, perto da entrada USB. Joy-Con: segure o botão sync na lateral até as luzes correrem.",
    pairOther: "Veja no manual como entrar em modo de pareamento. 8BitDo: ligue no modo X (Xbox) ou S (Switch) e segure o botão pair.",
    pairThen: "Volte ao jogo e aperte A no controle para entrar.",
    pairNote: "O pareamento é feito pelo sistema, uma vez só por controle: nenhum jogo consegue parear sozinho. Depois, basta ligar o controle.",
    diagTitle: "Diagnóstico",
    diagHint: "Aperte botões em cada controle: todos devem aparecer aqui. No iPhone, um controle só aparece depois do primeiro botão.",
    diagApiOk: "Este navegador lê controles",
    diagNoPads: "Nenhum controle visto ainda. Aperte um botão em cada um.",
    diagStandard: "Mapeamento padrão",
    diagNonStandard: "Mapeamento não padrão",
    diagRumble: "Vibração",
    diagButtons: "Botões",
    diagShowFps: "Mostrar FPS na partida",
    cpuName: "CPU {n}",
    map: "Mapa",
    slotHuman: "Jogador",
    slotOff: "Vazio",
    slotTakeHint: "A para entrar",
    slotClickHint: "Clique para jogar no teclado",
    keyboardPlay: "Jogar com o teclado",
    keyboardPlayHint: "Clique aqui ou aperte Espaço · com controle, aperte A",
    slotAdd: "Adicionar vaga",
    playersLabel: "Jogadores",
    cpuLevel: "Nível da CPU",
    needHuman: "Aperte A em um controle para entrar",
    summaryPlayers: "{n} tanques",
    summaryCpu: "{n} CPU",
    playersPadHint: "A entra · B sai · X/Y mais ou menos vagas · Start continua",
    playersKeysHint: "Teclado (até 2 no mesmo): Espaço (P1), Enter (P2); 2, 3 e 4 escolhem quantos",
    shuffle: "Sortear",
    readyToFight: "Prontos para a batalha!",
    readyToFightHint: "A ou Start para continuar",
  },
};

export default ptBR;
